import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TariffSummaryResults } from '../../../../assets/js/com/ts_api_client';

@Component({
    selector: 'bdo-tariff-details',
    templateUrl: './tariff-details.component.html',
    styleUrls: ['./tariff-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TariffDetailsComponent {

  @Input() tariffData: TariffSummaryResults;

}
